import React from 'react'
import { LeftCircleFilled, RightCircleFilled } from '@ant-design/icons'

const Slider = ({ onSlide, current, length, children }) => {
  const handleClick = (step) => {
    const newCurrent = current + step
    if (newCurrent >= 0 && newCurrent < length) {
      onSlide(newCurrent)
    }
  }
  return (
    <>
      <LeftCircleFilled
        className="pager"
        onClick={() => handleClick(-1)}
        disabled={current === 0}
      />
      {children}
      <RightCircleFilled
        className="pager"
        onClick={() => handleClick(+1)}
        disabled={current >= length - 1}
      />
    </>
  )
}

export default Slider
